// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks-css-min/" + {"67":"fancybox-css","323":"localizations","402":"experiences","594":"about","671":"services","794":"cases","962":"home"}[chunkId] + "" + __webpack_require__.h() + ".css";
};